"use client";

import React, { useState, useEffect, useRef } from "react";
import dynamic from "next/dynamic";

const RichTextEditor = dynamic(
  () => import("@/components/ui/rich-text-editor").then((m) => m.RichTextEditor),
  {
    ssr: false,
    loading: () => (
      <div className="min-h-[250px] rounded-md border bg-background" aria-busy="true" />
    ),
  }
);
import { useVariableDisplay } from "../variables/hooks/useVariableDisplay";
import { TemplatePreview } from "@/components/crm/templates/TemplatePreview";

interface UnifiedBodyFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  selectedClient?: any;
  email?: string;
  isSecondAccount?: boolean;
  onAttachmentsChange?: (
    attachments: Array<{
      id: string;
      filename: string;
      contentType: string;
      content: string;
      size: number;
    }>
  ) => void;
}

/**
 * Unified body field that shows the template for editing and provides a live preview below
 * This approach preserves the template while showing what it will look like with variables filled
 */
export function UnifiedBodyField({
  value,
  onChange,
  placeholder,
  className,
  selectedClient,
  email,
  isSecondAccount = false,
  onAttachmentsChange,
}: UnifiedBodyFieldProps) {
  const previewValue = useVariableDisplay(value, selectedClient);
  const hasVariables = value.includes("{{");

  return (
    <div className="space-y-3">
      <RichTextEditor
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={className}
        email={email}
        isSecondAccount={isSecondAccount}
        onAttachmentsChange={onAttachmentsChange}
      />

      {/* Show live preview when there are variables */}
      {hasVariables && (
        <TemplatePreview mode="inline" subject="" body={value} selectedClient={selectedClient} />
      )}
    </div>
  );
}
